/**
 * Audiobook chapters organized by topics
 * This file contains all audio chapter definitions with Cloudflare R2 URLs
 * Update the URLs here when you have the actual audio files
 */

import { AudioChapter } from '../types';

export const audiobookChapters: AudioChapter[] = [
  // Právo (Legal Studies) - 4 chapters done
{
  id: 'ustavni-pravo-principy',
  title: 'Ústavní právo',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.pravo/Pr%C3%A1vo/%C3%9Astavn%C3%AD_pr%C3%A1vo_%C4%8CR__Z%C3%A1klady_St%C3%A1tu%2C_Na%C5%A1e_Pr%C3%A1va_a_Role_%C3%9Astavn%C3%ADho_So.mp4'
},
{
  id: 'trestni-pravo-zaklady',
  title: 'Trestní právo',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.pravo/Pr%C3%A1vo/Trestn%C3%AD_pr%C3%A1vo_v_%C4%8CR__Od_kr%C3%A1de%C5%BEe_%C5%BEv%C3%BDka%C4%8Dek_po_do%C5%BEivot%C3%AD_%E2%80%93_Pr%C5%AFvodce_.mp4'
},
{
  id: 'pracovni-pravo-kapitola-v3-final',
  title: 'Pracovní právo',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.pravo/Pr%C3%A1vo/%C4%8Cesk%C3%A9_pracovn%C3%AD_pr%C3%A1vo__V%C5%A1e%2C_co_pot%C5%99ebujete_v%C4%9Bd%C4%9Bt_o_vztaz%C3%ADch%2C_sml.mp4'
},
{
  id: 'obcanske-pravo-kapitola-v2-final',
  title: 'Občanské právo',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.pravo/Pr%C3%A1vo/Ob%C4%8Dansk%C3%A9_pr%C3%A1vo_v_praxi__Od_rohl%C3%ADku_po_rozvod_a_d%C4%9Bdictv%C3%AD_%E2%80%93_Jak_s.mp4'
},
{
  id: 'pravni-proces-soudnictvi',
  title: 'Právní proces a soudnictví',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.pravo/Pr%C3%A1vo/Od_Chammurapiho_po_eJustice__Jak_se_vyv%C3%ADjelo_pr%C3%A1vo_a_soudnictv%C3%AD.mp4'
},
{
  id: 'legislativni-procesy-regulace',
  title: 'Legislativní procesy a regulace',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.pravo/Pr%C3%A1vo/Od_mapy_k_pohybu__Jak_kultura%2C_socializace_a_instituce_formuj%C3%AD_.mp4'
},



  // Psychologie (Psychology) - 10 chapters
  {
    id: 'uvod-do-psychologie',
    title: 'Úvod do psychologie',
    src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/PSYCHOLOGIE/Pr%C5%AFvodce_psychologi%C3%AD__Od_du%C5%A1e_k_v%C4%9Bd%C4%9B_a_praktick%C3%BDm_%C5%99e%C5%A1en%C3%ADm_pro_lep%C5%A1%C3%AD_%C5%BEivot.m4a'
  },
  {
    id: 'psychopatologie-poruchy',
    title: 'Psychopatologie a poruchy',
    src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/PSYCHOLOGIE/Cesta_psychopatologi%C3%AD__Od_d%C3%A9mon%C5%AF_k_bio-psycho-soci%C3%A1ln%C3%ADmu_modelu_a_boji_proti_stigmatu.m4a'
  },
  {
    id: 'vyvojove-teorie',
    title: 'Vývojové teorie',
    src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/PSYCHOLOGIE/Freud%2C_Erikson%2C_Piaget__Mapy_lidsk%C3%A9ho_v%C3%BDvoje_od_narozen%C3%AD_po_st%C3%A1%C5%99%C3%AD.m4a'
  },
  {
    id: 'socialni-psychologie',
    title: 'Sociální psychologie',
    src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/PSYCHOLOGIE/Neviditeln%C3%A1_vl%C3%A1kna__Jak_soci%C3%A1ln%C3%AD_psychologie_odhaluje_vliv_druh%C3%BDch_na_na%C5%A1e_chov%C3%A1n%C3%AD_a_pro%C4%8D_(ne)pom%C3%A1h%C3%A1.m4a'
  },
  {
    id: 'psychologicke-smery-a-pristupy',
    title: 'Psychologické směry a přístupy',
    src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/PSYCHOLOGIE/Cesta_psychikou__Od_Freuda_k_flow_%E2%80%93_jak_se_vyv%C3%ADjelo_ch%C3%A1p%C3%A1n%C3%AD_lidsk%C3%A9_mysli_.m4a'
  },
  {
    id: 'psychoterapeuticke-metody',
    title: 'Psychoterapeutické metody',
    src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/PSYCHOLOGIE/Cesta_psychoterapie__Od_autosugesce_k_mindfulness_a_hlubin%C3%A1m_mysli.m4a'
  },
  {
    id: 'inteligence-a-typologie-osobnosti',
    title: 'Inteligence a typologie osobnosti',
    src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/PSYCHOLOGIE/Od_Galtona_po_Big_Five__V%C3%BDvoj_ch%C3%A1p%C3%A1n%C3%AD_inteligence_a_osobnosti_v_psychologii.m4a'
  },
  {
    id: 'struktury-vedomi-a-nevedomi',
    title: 'Struktury vědomí a nevědomí',
    src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/PSYCHOLOGIE/V%C4%9Bdom%C3%AD_a_nev%C4%9Bdom%C3%AD__Od_Jamese_k_Jungovi_a_k_z%C3%A1had%C3%A1m_na%C5%A1%C3%AD_mysli_dnes.m4a'
  },
  {
    id: 'podminovani-a-uceni',
    title: 'Podmiňování a učení',
    src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/PSYCHOLOGIE/Jak_Se_U%C4%8D%C3%ADme__Kl%C3%AD%C4%8D_K_Pochopen%C3%AD_Zvyk%C5%AF%2C_Strach%C5%AF_I_Svobodn%C3%A9_V%C5%AFle_(Klasick%C3%A9_A_Operantn%C3%AD_Podmi%C5%88ov%C3%A1n%C3%AD).m4a'
  },
  {
    id: 'kognitivni-procesy',
    title: 'Kognitivní procesy',
    src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/PSYCHOLOGIE/Pro%C4%8D_je_mozek_jako_p%C5%99%C3%ADb%C4%9Bh__Vn%C3%ADm%C3%A1n%C3%AD%2C_u%C4%8Den%C3%AD%2C_pam%C4%9B%C5%A5_a_my%C5%A1len%C3%AD_pod_lupou_.m4a'
  },

  // Sociologie (Sociology) - 4 chapters done
  {
    id: 'soc-vyzkum-metody-pojmy',
    title: 'Úvod do sociologie',
    src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.sociologie/Sociologie/Pod_Pokli%C4%8Dkou_Sociologick%C3%A9ho_V%C3%BDzkumu__Jak_Ch%C3%A1peme_Sv%C4%9Bt_Kolem_N%C3%A1.mp4'
  },
  {
    id: 'kultura-a-socializace',
    title: 'Sociální struktury',
    src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.sociologie/Sociologie/Kultura%2C_Socializace_a_Mobilita__Jak_se_z_n%C3%A1s_st%C3%A1vaj%C3%AD_%C4%8Dlenov%C3%A9_s.mp4'
  },
  {
    id: 'vznik-a-vyvoj-sociologie',
    title: 'Sociální instituce',
    src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.sociologie/Sociologie/Od_Comta_po_Baumana__Kl%C3%AD%C4%8Dov%C3%A9_my%C5%A1lenky_sociologie_pro_pochopen%C3%AD_.mp4'
  },
  {
    id: 'socialni-struktura-role-deviace',
    title: 'Sociální změny',
    src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.sociologie/Sociologie/Neviditeln%C3%A9_S%C3%ADly_Spole%C4%8Dnosti__Role%2C_Stratifikace_a_Deviace_v_%C4%8Ce.mp4'
  },
  
//filosofie done
{
  id: 'ceska-filozofie-kapitola',
  title: 'Česká filozofie',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audioknihy%20filozofie/%C4%8Cesk%C3%A1_Filozofie__Od_Masaryka_k_Pato%C4%8Dkovi_%E2%80%93_Hled%C3%A1n%C3%AD_Smyslu_v_D%C4%9Bj.mp4'
},
{
  id: 'filosoficke-smery',
  title: 'Základní filosofické směry',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audioknihy%20filozofie/Pr%C5%AFvodce_z%C3%A1padn%C3%AD_filozofi%C3%AD__Od_antiky_po_AI_a_smysl_%C5%BEivota_%E2%80%93_Co_n%C3%A1m_%C5%99eknou_star%C3%A9_ot%C3%A1zky_dnes_.m4a'
},
{
  id: 'logika-argumentace',
  title: 'Logika a argumentace',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audioknihy%20filozofie/Od_Aristotela_po_AI__Logika%2C_Klamy_a_Limity_Lidsk%C3%A9ho_My%C5%A1len%C3%AD.m4a'
},
{
  id: 'filosofie-vedy',
  title: 'Filosofie vědy',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audioknihy%20filozofie/Od_Bacona_po_Latoura__Komplexn%C3%AD_ponor_do_filosofie_v%C4%9Bdy%2C_metody_a_jej%C3%ADho_vztahu_ke_spole%C4%8Dnosti.m4a'
},
{
  id: 'etika-moralka',
  title: 'Etika a morálka',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audioknihy%20filozofie/Od_Sokrata_po_AI__Cesta_etikou_od_antiky_k_dne%C5%A1n%C3%ADm_dilemat%C5%AFm_a_hled%C3%A1n%C3%AD_mor%C3%A1ln%C3%ADho_kompasu.m4a'
},
{
  id: 'epistemo-onto',
  title: 'Epistemologie a ontologie',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audioknihy%20filozofie/Epistemologie_a_Ontologie__Jak_pozn%C3%A1v%C3%A1me_sv%C4%9Bt_a_co_v_n%C4%9Bm_doopravdy_je_.m4a'
},
{
  id: 'religie',
  title: 'Filozofie religií',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audioknihy%20filozofie/Velk%C3%BDch_p%C4%9Bt__Cesta_pozn%C3%A1n%C3%AD_sv%C4%9Btov%C3%BDch_n%C3%A1bo%C5%BEenstv%C3%AD_z_pohledu_religionistiky.m4a'
},

//ekonomie done 
{
  id: 'zaklady-makro-mikro-ekonomie',
  title: 'Základy makroekonomie a mikroekonomie',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.ekonomie/Ekonomie/Magick%C3%BD_%C4%8Dty%C5%99%C3%BAheln%C3%ADk_%C4%8Desk%C3%A9_ekonomiky__Od_rozpo%C4%8Dtu_vl%C3%A1dy_po_n%C3%A1str.mp4'
},
{
  id: 'ekonomicke-proudy-historie',
  title: 'Základní myšlenkové proudy ekonomie napříč historií',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.ekonomie/Ekonomie/Mikro_a_makro__Jak_se_zorientovat_v_z%C3%A1kladech_ekonomie_od_HDP_p.mp4'
},
{
  id: 'hospodarska-politika-cnb',
  title: 'Hospodářská politika a Česká národní banka',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.ekonomie/Ekonomie/Od_Aristotela_k_um%C4%9Bl%C3%A9_inteligenci__Evoluce_ekonomick%C3%A9ho_my%C5%A1len%C3%AD.mp4'
},
{
  id: 'penize-a-bankovnictvi',
  title: 'Peníze a bankovnictví',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.ekonomie/Ekonomie/Pen%C3%ADze%2C_banky_a_finan%C4%8Dn%C3%AD_trhy__Jak_ovliv%C5%88uj%C3%AD_v%C3%A1%C5%A1_%C5%BEivot_a_kam_zm.mp4'
},
//politologie
{
  id: 'd2b8c3e4-f5a6-4789-b0c1-d2e3f4a5b6c7',
  title: 'Politický systém České republiky',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.politologie/Politologie/Jak_St%C3%A1t_Funguje__Od_Parlamentu_Po_E-Government_a_Pro%C4%8D_Na_Pravi.mp4'
},
{
  id: 'e3c9d4f5-a6b7-4890-c1d2-e3f4a5b6c7d8',
  title: 'Mezinárodní organizace',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.politologie/Politologie/Mezin%C3%A1rodn%C3%AD_Organizace__Kdo_H%C3%BDbe_Sv%C4%9Btem__Od_OSN_po_BRICS_a_Vyzv.mp4'
},
{
  id: 'f4d0e5f6-b7c8-4901-d2e3-f4a5b6c7d8e9',
  title: 'Politické strany a stranické systémy',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.politologie/Politologie/%C4%8Cesk%C3%A9_politick%C3%A9_strany__Kl%C3%AD%C4%8D_k_pochopen%C3%AD_nest%C3%A1l%C3%A9_demokracie_a_p.mp4'
},
{
  id: 'g5e1f6a7-c8d9-5012-e3f4-g5a6b7c8d9f0',
  title: 'Mezinárodní vztahy a geopolitika',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.politologie/Politologie/Od_Geografie_po_AI__Jak_Rozum%C4%9Bt_Prom%C4%9Bn%C3%A1m_Sv%C4%9Btov%C3%A9_Politiky_a_Sou.mp4'
},
{
  id: 'h6f2g7b8-d9e0-6123-f4g5-h6b7c8d9f0g1',
  title: 'Politické systémy a režimy',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.politologie/Politologie/Demokracie_vs._Autoritarismus_vs.mp4'
},
{
  id: 'i7g3h8c9-e0f1-7234-g5h6-i7c8d9f0g1h2',
  title: 'Rozdělení moci a ústavní principy',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.politologie/Politologie/D%C4%9Blba_moci_a_%C3%BAstavn%C3%AD_principy__%C5%A0t%C3%ADt_demokracie_v_prom%C4%9Bnliv%C3%A9m_sv.mp4'
},
{
  id: 'j8h4i9d0-f1g2-8345-h6i7-j8d9f0g1h2i3',
  title: 'Teorie státu a politické ideologie',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.politologie/Politologie/Pro%C4%8D_m%C3%A1me_st%C3%A1ty__Od_teori%C3%AD_vzniku_a_ideologi%C3%AD_k_sou%C4%8Dasn%C3%BDm_v%C3%BDzv%C3%A1.mp4'
},
{
  id: 'k9i5j0e1-g2h3-9456-i7j8-k9e0f1g2h3i4',
  title: 'Instituce a volební systémy',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.politologie/Politologie/Od_%C3%9Astavy_po_Sn%C4%9Bmovnu__Kl%C3%AD%C4%8Dov%C3%A9_Mechanismy_a_Aktu%C3%A1ln%C3%AD_V%C3%BDzvy_%C4%8Cesk.mp4'
},

//eu

{
  id: 'evropska-integrace-kapitola',
  title: 'Historie a vývoj evropské integrace',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.evropa/Evropsk%C3%A1%20integrace/Od_Uhl%C3%AD_a_Oceli_k_Euroz%C3%B3n%C4%9B__Cesta_Evropsk%C3%A9_Unie_a_%C4%8Ceska_nap%C5%99%C3%AD%C4%8D_.mp4'
},
{
  id: 'pravo-eu-kapitola',
  title: 'Právo EU a současné výzvy',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.evropa/Evropsk%C3%A1%20integrace/Pr%C3%A1vo_EU__Unik%C3%A1tnost%2C_V%C3%BDzvy_a_Budoucnost_%E2%80%93_Od_Brexitu_po_Green_.mp4'
},
{
  id: 'schengen-politiky-eu-kapitola',
  title: 'Schengen a hlavní politiky EU',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.evropa/Evropsk%C3%A1%20integrace/Institucion%C3%A1ln%C3%AD_%C4%8Dty%C5%99%C3%BAheln%C3%ADk__Jak_Evropsk%C3%A1_unie_skute%C4%8Dn%C4%9B_funguje-1.mp4'
},
{
  id: 'euro-integrace-kapitola',
  title: 'Euro a hospodářská integrace',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.evropa/Evropsk%C3%A1%20integrace/Euro_jako_symbol%2C_experiment_i_v%C3%BDzva__Od_vzniku_po_krize_a_dile.mp4'
},

//moderni dejiny
{
  id: 'moderni-dejiny-kapitola',
  title: 'Moderní dějiny (1848-1918)',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.dejiny/Modern%C3%AD%20d%C4%9Bjiny/Cesta_k_samostatnosti__%C4%8Cesk%C3%A9_d%C4%9Bjiny_1848%E2%80%931918_%E2%80%93_Od_probuzen%C3%AD_n%C3%A1.mp4'
},
{
  id: 'moderni-dejiny-2-kapitola-v2-final',
  title: 'Moderní dějiny (1918-1945)',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.dejiny/Modern%C3%AD%20d%C4%9Bjiny/Od_nad%C4%9Bje_k_trag%C3%A9dii__%C4%8Ceskoslovensko%2C_totality_a_cesta_k_druh%C3%A9_.mp4'
},
{
  id: 'moderni-dejiny-3-kapitola-v2-final',
  title: 'Moderní dějiny (po roce 1945)',
  src: 'https://pub-e58ab5ad672d488f861a2919647e4793.r2.dev/audio.dejiny/Modern%C3%AD%20d%C4%9Bjiny/Od_Jalty_po_p%C3%A1d_Zdi__Cesta_%C4%8Ceskoslovenska_a_sv%C4%9Bta_Studenou_v%C3%A1lk.mp4'
}




];


// Helper function to get chapters by topic
export const getChaptersByTopic = (topicId: string): AudioChapter[] => {
  // This would need to be implemented based on your chaptersIndex mapping
  // For now, return all chapters - you can refine this later
  return audiobookChapters;
};

// Helper function to get a specific chapter
export const getChapterById = (chapterId: string): AudioChapter | undefined => {
  return audiobookChapters.find(chapter => chapter.id === chapterId);
};